import Link from 'next/link';
import styled from 'styled-components';

export const BasketIconWrapper = styled.div`
  position: relative;
`;

export const BasketIconBadge = styled.div`
  position: absolute;
  right: 0;
  top: 2px;
  width: 8px;
  height: 8px;
  z-index: 1;
  background: ${({ theme }) => theme.palette.red600};
  border-radius: 50%;
`;

export const StyledLink = styled(Link)`
  &&& {
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.75;
    }
  }
`;
